import axios from "../axios";
// 获取学科列表
export const getHomeWorkist = (data) => {
  return axios({
    url: "/console/homework/statistic",
    method: "GET",
    data: data,
  });
};

// 添加教师
export const addTeacher = (data) => {
  return axios({
    url: "/console/teacher/save",
    method: "POST",
    data,
  });
};

// 查询学校列表
export const getSchoolist = (data) => {
  return axios({
    url: "/console/school/pageForCurrentEducation",
    method: "GET",
    data: data,
  });
};

// 获取作业详情
export const getDetails = (data) => {
  return axios({
    url: "/console/homework/statistic/detail",
    method: "GET",
    data: data,
  });
};
// 作业分析-年级作业列表分析分页
export const getGradeAnalysisList = (data) => {
  return axios({
    url: "/console/homework/gradeAnalysisList",
    method: "GET",
    data: data,
  });
};
// 作业分析-年级作业列表折线图
export const getGradeAnalysisChart = (data) => {
  return axios({
    url: "/console/homework/gradeAnalysisChart",
    method: "GET",
    data: data,
  });
};
// 作业分析-学科列表
export const getSubjectAnalysisList = (data) => {
  return axios({
    url: "/console/homework/subjectAnalysisList",
    method: "GET",
    data: data,
  });
};
// 作业分析-学科列表
export const getSubjectAnalysisChart = (data) => {
  return axios({
    url: "/console/homework/subjectAnalysisChart",
    method: "GET",
    data: data,
  });
};



// WEBPACK FOOTER //
// ./src/http/moudules/jobStatistics.js